import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch policies for a specific community
 */
export const GET_COMMUNITY_POLICIES = gql`
  query GetCommunityPolicies($communityId: ID!) {
    community(id: $communityId) {
      id
      policies {
        id
        communityId
        name
        description
        isEnabled
        workflowType
        labels {
          labelId
          severity
          scoreThreshold
        }
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
      }
    }
  }
`;
